import TransactionTransferList from './transaction-transfer.list';

export default {
  list: TransactionTransferList,
};
